<div class="footer">
  <button class="footer__btn">
    <a href="https://github.com/DanaDovzh/test-task-decerto" target="_blank" class="footer__btn__link">
      GitHub
      <mat-icon class="footer__btn__icon">home</mat-icon>
    </a>
  </button>
</div>
